<div class="post d-flex flex-column-fluid">
	<div class="container">
		<div class="card" style="margin-top: 15px; height: 97vh">
			<div class="card-body p-0 esign-container d-flex justify-content-center align-items-center">
				<div class="card-px">
					@if (isLoading) {
						<div class="d-flex align-items-center justify-content-center text-center">
							<div class="spinner-border text-success me-3" style="width: 2.75rem; height: 2.75rem" role="status"></div>
							<h4 class="mb-0">Authorizing - Please wait...</h4>
						</div>
					}

					@if (alert) {
						<div class="alert bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 mt-5 text-center">
							<i class="fas fa-exclamation-triangle fs-2hx text-danger me-4 mb-5 mb-sm-0"></i>
							<div class="d-flex flex-column pe-0 pe-sm-10">
								<h5 class="mb-1">{{ alert.title }}</h5>
								<span>{{ alert.message }}</span>
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
</div>